var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uupy"},[_c('dashboard',{attrs:{"uppy":_vm.uppy}}),(_vm.show && this.path !='')?_c('button',{staticClass:"up_file",on:{"click":function($event){return _vm.sendData(_vm.uppy)}}},[_vm._v("下一步")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }